var O = /* @__PURE__ */ ((N) => (N[N.STAMP = 1] = "STAMP", N[N.POINT = 2] = "POINT", N[N.NONE = 3] = "NONE", N))(O || {});
export {
  O as ProgrammeType
};
//# sourceMappingURL=programmeSettingsTypes.js.map
